import { useMemo } from 'react';

import { useQueryParams } from '@/utils';
const QUERY_KEY = 'id';
const useGetInvestorAccountId = () => {
  const query = useQueryParams();
  const accountId = useMemo(() => query.get(QUERY_KEY) || '' , [ query]);
  
  return accountId;
};

export default useGetInvestorAccountId;